import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Callout, RowsSkeletonLoader } from '@node-space/ui-components'
import { useRecurringExportContext } from 'hooks/context/useRecurringExportContext'
import { useReportScheduleQuery } from 'hooks/queries/useReportScheduleQuery'
import { RecurringExportSteps } from 'types/walletTransactionsExport'
import { ReportScheduleItem } from './ReportSchedule'

export const RecurringExportList = () => {
  const { t } = useTranslation()
  const [isDeleteError, setIsDeleteError] = useState(false)
  const { setStep } = useRecurringExportContext()
  const { data: reportSchedules = [], isFetching, isError } = useReportScheduleQuery(true)

  useEffect(() => {
    if (!isFetching && !isError && !reportSchedules?.length) {
      setStep(RecurringExportSteps.FORM)
    }
  }, [isFetching, isError, reportSchedules])

  return (
    <Box flex flexCol gap={16}>
      {isFetching && <RowsSkeletonLoader rows={1} />}
      {isError && !isFetching && (
        <Callout variant="error">{t('exports.scheduledReportsError')}</Callout>
      )}
      {!isFetching && !isError && !!reportSchedules?.length && (
        <>
          {reportSchedules?.map(reportSchedule => {
            return (
              <ReportScheduleItem
                key={reportSchedule?.id}
                reportSchedule={reportSchedule}
                setIsDeleteError={setIsDeleteError}
              />
            )
          })}
        </>
      )}
      {isDeleteError && <Callout variant="error">{t('exports.deleteReportScheduleError')}</Callout>}
    </Box>
  )
}
